import { BrowserRouter } from 'react-router-dom';
import { Notification } from '@widgets';
import { Root } from '@routes';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'react-datepicker/dist/react-datepicker.css';

export const App = () => {
  return (
    <BrowserRouter>
      <Notification />
      <Root />
    </BrowserRouter>
  );
};
